import type { Action } from '@reduxjs/toolkit';
import type { SagaIterator } from 'redux-saga';
import { call, select, takeEvery } from 'redux-saga/effects';
import type { RootState } from '../store/store';
import { captureUnexpectedError } from '../utils/sentry';

interface ActionWithCause extends Action {
  meta: { cause: unknown; context?: Record<string, unknown> };
}

const hasCause = (action: unknown): action is ActionWithCause =>
  Boolean((action as ActionWithCause | undefined)?.meta?.cause);

function* selectContext(): SagaIterator<Record<string, unknown>> {
  return (yield select((state: RootState) => ({
    route: state.routing?.id,
    cartProducts: state.cart.persistentCart?.products?.map((p) => p.ratePlan),
    promoCode: state.cart.promoCode || undefined,
    signedIn: Boolean(state.app.session?.Email),
    country: state.billing.form?.country,
  }))) as Record<string, unknown>;
}

function* reportCause(action: ActionWithCause): SagaIterator<void> {
  const context = yield call(selectContext);
  yield call(captureUnexpectedError, action.meta.cause, {
    action: action.type,
    ...context,
    ...action.meta.context,
  });
}

export function* watchReportedErrors(): SagaIterator<void> {
  yield takeEvery(hasCause, reportCause);
}
